import { faShieldExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonIcon } from '@morressier/alembic';

const AnomalyDetectionIcon: React.FC = () => (
  <ButtonIcon
    size="small"
    ariaLabel="AnomalyDetectionIcon"
    icon={<FontAwesomeIcon color="red" icon={faShieldExclamation} />}
    data-cy="Anomaly-Detection-Icon"
  />
);

export default AnomalyDetectionIcon;
